import ChartComponent from './ChartComponent'
import TableComponent from './TableComponent'
import classes from './index.module.scss'

const BaseContainer = () => {
  return (
    <div className={classes.container}>
      <div className={classes.row}>
        <ChartComponent />
        <TableComponent />
      </div>
    </div>
  )
}

export default BaseContainer
